import { render } from "./CustomsClearance.html?vue&type=template&id=1626f7c8&ts=true&external"
import script from "./CustomsClearance.vue?vue&type=script&lang=ts"
export * from "./CustomsClearance.vue?vue&type=script&lang=ts"

import "./CustomsClearance.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__